import { Variant } from 'react-bootstrap/esm/types'
import { store, toastsAtom } from '../store'
import { v4 as uuidv4 } from 'uuid'

type NewToast = {
  title: string
  message: string
  variant?: Variant
}

export type Toast = NewToast & { id: string }

const add = (toast: NewToast, duration = 5) => {
  const id = uuidv4()
  store.set(toastsAtom, (toasts) => {
    return [...toasts, { ...toast, id }]
  })
  if (duration > 0) {
    setTimeout(() => remove(id), duration * 1000)
  }
}

const remove = (id: string) => {
  const toasts = store.get(toastsAtom)
  store.set(
    toastsAtom,
    toasts.filter((t) => t.id !== id)
  )
}

export default {
  add,
  remove,
}
